import {uuid4} from "../..";
import {clear} from "../../../store/common/localStorageManager";
import {parseParam} from "../index";
import {AESEncrypt} from "../../crypto";
import {getValue, setValue} from "../../../store/common/CacheGlobal";
import {openLoginModal} from "../../../constant/web";

/**
 * 跳转路由函数
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const routeJumpFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) === 1 || _size(_get(func, 'inParams')) === 2 || _size(_get(func, 'inParams')) === 3) {
    let attrsObject, url, wodeFlag
    let menuRouting = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    if (_size(_get(func, 'inParams')) === 2) {
      menuRouting = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
      wodeFlag = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
    }
    if (_size(_get(func, 'inParams')) < 3) {
      url = menuRouting.id
      // /login 改为弹窗，不跳转路由
      if (url === '/login') {
        clear();
        openLoginModal();
        return;
      }
    }
    if (_size(_get(func, 'inParams')) === 3) {
      attrsObject = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
      let menuRouting = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
      wodeFlag = await parseParam(_get(func, 'inParams')[2], customParamsList, customFunctionParams, instanceId);
      if (menuRouting?.id === '/login') {
        clear();
        openLoginModal();
        return;
      }
      const key = uuid4()
      // 缓存数据对象
      await setValue(key, attrsObject);
      // 缓存数据存入时间戳，后面计算过期时间时使用.
      await setValue(`timestamp_${key}`, Date.now());
      url = buildPathWithParams(menuRouting.id, {key});
    }
    if (wodeFlag) {
      wodeFlag = true;
    }
    console.log("跳转地址--->>>", url);
    if (wodeFlag) {
      window.open(url, '_blank').focus();
    } else {
      window.open(url, '_self').focus();
    }
  }


}


export const buildPathWithParams = (path, params = {}, options = {}) => {
  // 默认配置
  const defaultOptions = {
    keepNull: false,
    keepUndefined: false,
    serializer: (obj) => JSON.stringify(obj)
  };

  const mergedOptions = {...defaultOptions, ...options};

  // 移除路径中可能存在的原有查询参数和hash
  const [cleanPath] = path.split(/[?#]/);

  // 处理参数
  const queryString = buildQueryString(params, mergedOptions);

  // 组合结果
  return queryString ? `${cleanPath}?${queryString}` : cleanPath;
}

/**
 * 构建查询字符串
 * @param {object} params 参数对象
 * @param {object} options 配置选项
 * @returns {string} 查询字符串
 */
const buildQueryString = (params, options) => {
  return Object.entries(params)
    .flatMap(([key, value]) => {
      // 处理undefined
      if (value === undefined) {
        return options.keepUndefined
          ? [`${encodeURIComponent(key)}=undefined`]
          : [];
      }

      // 处理null
      if (value === null) {
        return options.keepNull
          ? [`${encodeURIComponent(key)}=null`]
          : [];
      }

      // 处理数组
      if (Array.isArray(value)) {
        return value.map(v => encodeParam(key, v, options));
      }

      // 处理其他类型
      return [encodeParam(key, value, options)];
    })
    .join('&');
}

/**
 * 编码单个参数
 * @param {string} key 参数名
 * @param {any} value 参数值
 * @param {object} options 配置选项
 * @returns {string} 编码后的键值对
 */
const encodeParam = (key, value, options) => {
  // 处理对象类型
  if (typeof value === 'object') {
    const serialized = options.serializer(value);
    return `${encodeURIComponent(key)}=${encodeURIComponent(serialized)}`;
  }

  // 处理日期类型
  if (value instanceof Date) {
    return `${encodeURIComponent(key)}=${encodeURIComponent(value.toISOString())}`;
  }

  // 处理其他类型（转为字符串）
  return `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`;
}

/**
 * 解析浏览器地址函数
 */
export const parseAddressFunction = async () => {
  const searchParams = new URLSearchParams(window.location.search);
  let params = {};
  if (!searchParams.has('')) {
    params = null
  }
  for (const [_, value] of searchParams.entries()) {
    params = await getValue(value);
    // deleteKey(value);
  }
  console.log("parseAddressFunction----------", params);
  return params;
}

/**
 * 外链跳转
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const externalLinkFunction = async (func, customParamsList, customFunctionParams, instanceId) => {
  let url: string, flag: boolean, encryptionFlag: boolean, componentObject: object
  if (_size(_get(func, 'inParams')) === 2 || _size(_get(func, 'inParams')) === 3 || _size(_get(func, 'inParams')) === 4) {
    url = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
    flag = await parseParam(_get(func, 'inParams')[1], customParamsList, customFunctionParams, instanceId);
  }
  if (_size(_get(func, 'inParams')) === 3) {
    componentObject = await parseParam(_get(func, 'inParams')[2], customParamsList, customFunctionParams, instanceId);
  }
  if (_size(_get(func, 'inParams')) === 4) {
    encryptionFlag = await parseParam(_get(func, 'inParams')[2], customParamsList, customFunctionParams, instanceId);
    componentObject = await parseParam(_get(func, 'inParams')[3], customParamsList, customFunctionParams, instanceId);
  }
  if (encryptionFlag) {
    url = `${url}?formData=${encodeURIComponent(AESEncrypt(JSON.stringify(componentObject)))}`;
  } else {
    if (componentObject){
      let params = Object.keys(componentObject).map((key) => {
        return `${key}=${encodeURIComponent(componentObject[key])}`
      })
      url = `${url}?${params.join('&')}`
    }
  }
  console.log("外链地址--->>>", url);
  if (flag) {
    window.open(url, '_blank').focus();
  } else {
    window.open(url, '_self').focus();
  }
}
